import { useEffect, useState, useCallback } from "react";
import { onAchievementUnlocked } from "../store/gamification-store";
import { getAchievementById, type Achievement } from "../achievements";

export interface ToastEntry {
  readonly id: number;
  readonly achievement: Achievement;
}

interface AchievementToastState {
  readonly toasts: readonly ToastEntry[];
  readonly dismiss: (id: number) => void;
}

const MAX_TOASTS = 5;
let nextId = 0;

export function useAchievementToast(): AchievementToastState {
  const [toasts, setToasts] = useState<ToastEntry[]>([]);

  useEffect(() => {
    return onAchievementUnlocked((achievementId) => {
      const achievement = getAchievementById(achievementId);
      if (!achievement) return;

      setToasts((prev) => {
        // Ne pas afficher un toast pour un achievement déjà visible
        if (prev.some((t) => t.achievement.id === achievementId)) return prev;
        const id = nextId++;
        const next = [...prev, { id, achievement }];
        return next.length > MAX_TOASTS ? next.slice(-MAX_TOASTS) : next;
      });
    });
  }, []);

  const dismiss = useCallback((id: number) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  return { toasts, dismiss };
}
